import { render, staticRenderFns } from "./TreatmentSelect.vue?vue&type=template&id=339b1e08&scoped=true&"
import script from "./TreatmentSelect.vue?vue&type=script&lang=js&"
export * from "./TreatmentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339b1e08",
  null
  
)

export default component.exports